
const processedUrls = []
function main() {
  // Don't send duplicate events if we've already processed the page, e.g. if replaceState is called with the same URL.
  if (processedUrls.includes(window.location.href)) {
    return
  }
  processedUrls.push(window.location.href)
  window.htevents.page(undefined, undefined, {}, { sent_from: 'Hightouch JS' })
  identifyIfLoggedIn()
  saveAnonymousIdToCart()
  switch (window?.ShopifyAnalytics?.meta?.page?.pageType) {
    case 'product':
      sendProductViewedEvent()
      break
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main)
} else {
  main()
}
// Send the product viewed event if appropriate when the variant changes.
window.addEventListener('popstate', main)
// Send the product viewed event if appropriate when the variant changes.
const replaceState = history.replaceState
history.replaceState = function() {
  replaceState.apply(history, arguments)
  main()
}
// Send the product viewed event if appropriate when the variant changes.
const pushState = history.pushState
history.pushState = function() {
  pushState.apply(history, arguments)
  main()
}
async function saveAnonymousIdToCart() {
  if (!window.htevents.initialized) {
    await new Promise((resolve) => window.htevents.on('initialize', resolve))
  }
  // There's a slight delay between the SDK being initialized, and it being
  // available in `window.htevents`.
  while (typeof window.htevents.user !== "function") {
    await new Promise((resolve) => setTimeout(resolve, 500));
  }
  const anonymousId = window.htevents.user().anonymousId()
  const cartInfo = await getCartInfo()
  if (cartInfo.attributes?.htAnonymousId === anonymousId) {
    return
  }
  await updateCartAttributes({
    htAnonymousId: anonymousId,
  })
}
async function sendProductViewedEvent() {
  const productSlug = parseProductSlug(window.location.href)
  if (!productSlug) {
    return
  }
  const productInfo = await getProductInfo(productSlug.handle)
  const variant = productInfo.variants.find(
    (variant) => variant.id == productSlug.variant,
  )
  window.htevents.track(
    'Product Viewed',
    {
      brand: productInfo.vendor,
      category: productInfo.product_type,
      currency: window.Shopify.currency.active,
      name: productInfo.title,
      price: variant?.price,
      sku: variant?.sku,
      variant: variant?.title,
      shopify_variant_id: variant?.id,
      compare_at_price: variant?.compare_at_price,
      shopify_product_id: variant?.product_id,
      image_url: productInfo.image.src,
    },
    { sent_from: 'Hightouch JS' },
  )
}
function parseProductSlug(link) {
  const handleMatches = link.match(/\/products\/((\w|-)*)(\?|\$?)/)
  if (!handleMatches || handleMatches.length <= 1) {
    return null
  }
  const handle = handleMatches[1]
  // TODO: VB doesn't implement variant so this parsing doesn't work. They have custom parameters for color etc.
  const variantMatches = link.match(/variant=([a-z,A-Z,0-9,-]+)/)
  if (!variantMatches || variantMatches.length <= 1) {
    return { handle, variant: '' }
  }
  return { handle, variant: variantMatches[1] }
}
async function getProductInfo(product) {
  return new Promise((resolve, reject) => {
    const xmlhttp = new XMLHttpRequest()
    xmlhttp.open('GET', `/products/${product}.json`)
    xmlhttp.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        resolve(JSON.parse(this.responseText).product)
      } else {
        reject(this.statusText)
      }
    }
    xmlhttp.onerror = function() {
      reject(this.statusText)
    }
    xmlhttp.send()
  })
}
async function getCartInfo() {
  return new Promise((resolve, reject) => {
    const xmlhttp = new XMLHttpRequest()
    xmlhttp.open('GET', '/cart.js')
    xmlhttp.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        resolve(JSON.parse(this.responseText))
      } else {
        reject(this.statusText)
      }
    }
    xmlhttp.onerror = function() {
      reject(this.statusText)
    }
    xmlhttp.send()
  })
}
async function updateCartAttributes(attributes) {
  return new Promise((resolve, reject) => {
    const xmlhttp = new XMLHttpRequest()
    xmlhttp.open('POST', '/cart/update.js')
    xmlhttp.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        resolve(JSON.parse(this.responseText))
      } else {
        reject(this.statusText)
      }
    }
    xmlhttp.onerror = function() {
      reject(this.statusText)
    }
    xmlhttp.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    xmlhttp.send(JSON.stringify({ attributes }))
  })
}
async function getCartItem(id) {
  return new Promise((resolve, reject) => {
    const xmlhttp = new XMLHttpRequest()
    xmlhttp.open('GET', '/cart.js')
    xmlhttp.onload = function() {
      if (this.status >= 200 && this.status < 300) {
        const resp = JSON.parse(this.responseText)
        resolve({
          cartToken: resp.token,
          item: resp.items.find((item) => item.id === id),
        })
      } else {
        reject(this.statusText)
      }
    }
    xmlhttp.onerror = function() {
      reject(this.statusText)
    }
    xmlhttp.send()
  })
}
const open = window.XMLHttpRequest.prototype.open
function openWithTracking() {
  this.addEventListener('load', function() {
    if (this._url?.endsWith('/cart/change.js')) {
      handleCartChange(JSON.parse(this.response))
    } else if (
      this._url?.endsWith('/cart/add') ||
      this._url?.endsWith('/cart/add.js')
    ) {
      handleCartAdd(JSON.parse(this.response))
    }
  })
  return open.apply(this, arguments)
}
window.XMLHttpRequest.prototype.open = openWithTracking;
(function(ns, fetch) {
  if (typeof fetch !== 'function') {
    return
  }
  ns.fetch = function() {
    const response = fetch.apply(this, arguments)
    response.then(async(res) => {
      try {
        if (
          res.url?.endsWith('/cart/change.js') ||
          res.url?.endsWith('/cart/change')
        ) {
          handleCartChange(await res.clone().json())
        } else if (
          res.url?.endsWith('/cart/add.js') ||
          res.url?.endsWith('/cart/add')
        ) {
          handleCartAdd(await res.clone().json())
        }
      } catch (err) {
        console.log('Unexpected error in fetch callback', err)
      }
    })
    return response
  }
})(window, window.fetch)
async function handleCartChange(cartChangeResponseJson) {
  for (const item of cartChangeResponseJson.items_removed) {
    window.htevents.track(
      'Product Removed',
      {
        cart_token: cartChangeResponseJson.token,
        category: item.product_type,
        currency: window.Shopify.currency.active,
        brand: item.vendor,
        name: item.title,
        price: item.price,
        quantity: item.quantity,
        shopify_product_id: item.product_id,
        shopify_variant_id: item.variant_id,
        sku: item.sku,
        variant: item.untranslated_variant_title,
        image_url: item.image,
      },
      { sent_from: 'Hightouch JS' },
    )
  }
}
async function handleCartAdd(cartAddResponseJson) {
  for (const addItem of cartAddResponseJson.items) {
    const { item, cartToken } = await getCartItem(addItem.id)
    const productInfo = await getProductInfo(item.handle)
    const variantInfo = productInfo.variants.find(
      (variant) => variant.id === item.variant_id,
    )
    window.htevents.track(
      'Product Added',
      {
        title: item.title,
        cart_token: cartToken,
        category: item.product_type,
        currency: window.Shopify.currency.active,
        brand: item.vendor,
        name: item.product_title,
        price: variantInfo.price,
        quantity: item.quantity,
        shopify_product_id: item.product_id,
        shopify_variant_id: item.variant_id,
        sku: item.sku,
        variant: item.variant_title,
        compare_at_price: variantInfo.compare_at_price,
        image_url: item.image,
        url: item.url,
      },
      { sent_from: 'Hightouch JS' },
    )
  }
}
function identifyIfLoggedIn() {
  const webPixelsElement = window.document.getElementById(
    'web-pixels-manager-setup',
  )
  if (webPixelsElement == null) {
    return
  }
  const userStart = webPixelsElement.innerHTML.indexOf('"customer"')
  if (userStart == null) {
    return
  }
  const userEnd = webPixelsElement.innerHTML
    .substring(userStart)
    .indexOf('"productVariants"')
  if (userEnd == null) {
    return
  }
  const userJson = JSON.parse(
    `{${
      webPixelsElement.innerHTML.substring(userStart, userStart + userEnd - 1)
    }}`,
  )
  if (userJson?.customer == null) {
    return
  }
  const customer = userJson.customer
  window.htevents.identify(
    customer.id,
    {
      email: customer.email,
      first_name: customer.firstName,
      last_name: customer.lastName,
      phone: customer.phone ? customer.phone : customer.address?.phone,
      default_address: customer.address,
    },
    { sent_from: 'Hightouch JS' },
  )
}